/**
 * meApi — resolve o perfil do usuário autenticado via `GET /me` (M1).
 *
 * Chamado logo após o login para descobrir o grupo/perfil (que o backend
 * resolve a partir dos claims do JWT + tabela `usuario`) e ajustar a navegação
 * (RF-M11-013). Resposta no envelope `{ data }` do projeto.
 *
 * Nenhum dado pessoal é logado (RN-M11-001); o JWT é anexado pelo ApiClient.
 */

import { ApiClient } from './apiClient';

/** Perfis de acesso (grupos Cognito). */
export type Perfil = 'consulta' | 'editor' | 'admin';

/** Resposta do GET /me (CONTRATO CONGELADO — BINDING). */
export interface Me {
  readonly id: string;
  readonly email: string;
  readonly perfil: Perfil;
  readonly mfaAtivo: boolean;
}

interface Envelope<T> {
  readonly data: T;
}

export class MeApi {
  constructor(private readonly client: ApiClient) {}

  /** GET /me — perfil do usuário autenticado. */
  async me(): Promise<Me> {
    const resp = await this.client.request<Envelope<Me>>('/me');
    return resp.data;
  }
}
